import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import { ChallengeStatusDto } from '@/generated-sources/openapi';
import ChallengeDetailClosedStatus from './ChallengeDetailClosedStatus';
import ChallengeProgressBar from './ChallengeProgressBar';
const ChallengeDetailStatus = ({ challenge }) => {
    switch (challenge.status) {
        case ChallengeStatusDto.InProgress:
            return (_jsx(ChallengeProgressBar, { contributionsCount: challenge.contributionsCount, goal: challenge.goal, milestones: challenge.milestones }));
        case ChallengeStatusDto.Closed:
            return _jsx(ChallengeDetailClosedStatus, {});
        case ChallengeStatusDto.Upcoming:
            return null;
        default:
            return challenge.status;
    }
};
export default ChallengeDetailStatus;
